var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "var(--color-secondary-dark)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 9.25h5.25a5.625 5.625 0 015.625 5.625v5.25a5.625 5.625 0 01-5.625 5.625h-5.25a5.625 5.625 0 01-5.625-5.625v-5.25a5.625 5.625 0 015.625-5.625zm0 1.875a3.75 3.75 0 00-3.75 3.75v5.25a3.75 3.75 0 003.75 3.75h5.25a3.75 3.75 0 003.75-3.75v-5.25a3.75 3.75 0 00-3.75-3.75zm6.938 1.688a.938.938 0 11-.938.937.938.938 0 01.938-.938zm-5.063.562a3.375 3.375 0 11-3.375 3.375 3.375 3.375 0 013.375-3.375zm0 1.875a1.5 1.5 0 101.5 1.5 1.5 1.5 0 00-1.5-1.5z",
    fill: "#FFF"
  })));
}
export default SvgInstagram;